<template>
  <main class="history">
    <section v-if="columnMax">
      <h1>История просмотров</h1>

      <div v-if="calendar.length" class="calendar">
        <div v-for="item in calendar" :key="`ca-${item.date}`">
          <div :title="item.count" class="column">
            <span :style="`height:${(item.count / columnMax) * 100}%`" />
          </div>
          <div class="date">{{ item.date | filterDateShort }}</div>
        </div>
      </div>

      <div v-if="items.length" class="list">
        <div v-for="(anime, i) in items" :key="`anime-${anime.anime_id}`" class="anime">
          <div class="poster">
            <img :src="filmPoster(anime)" :alt="anime.title_ru">
          </div>
          <div class="body">
            <div class="title">
              <nuxt-link :to="`/smotrim?id=${anime.anime_id}`">{{ anime.title_ru }}</nuxt-link>
              <span>{{ anime.title_en }}</span>
            </div>
            <div class="items">
              <div v-for="item in items[i].items" :key="`item-${item.date}`" class="item">
                <span v-if="item.date">{{ item.date | filterDate }}</span>
                <span v-if="item.se.translation">{{ item.se.translation }}</span>
                <span v-if="item.se.season">Сезон {{ item.se.season }}</span>
                <span v-if="item.se.episode">Серия {{ item.se.episode }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else>
      <h1>История просмотров не доступна</h1>
    </section>
  </main>
</template>

<script>
export default {
  head() {
    const fullPath = `https://animeitochka.ru/profile/history`
    return {
      title: `История просмотров`,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: fullPath
        }
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `История просмотра аниме`
        }
      ]
    }
  },
  filters: {
    filterDate(val) {
      const day = new Date(val).getDate() < 10 ? `0${new Date(val).getDate()}` : new Date(val).getDate()
      const month = new Date(val).getMonth() + 1 < 10 ? `0${new Date(val).getMonth() + 1}` : new Date(val).getMonth() + 1
      const year = new Date(val).getFullYear() < 10 ? `0${new Date(val).getFullYear()}` : new Date(val).getFullYear()
      
      return `${day}.${month}.${year}`
    },
    filterDateShort(val) {
      const day = new Date(val).getDate() < 10 ? `0${new Date(val).getDate()}` : new Date(val).getDate()
      // const month = new Date(val).getMonth() + 1 < 10 ? `0${new Date(val).getMonth() + 1}` : new Date(val).getMonth() + 1
      
      return `${day}`
    }
  },
  async asyncData({ $axios, error }) {
    const { data } = await $axios.get(`/api/history`)

    if (data.error) return error(data.error)

    const calendar = data.calendar.length ? data.calendar.slice(0) : null

    return {
      items: data.list,
      calendar: data.calendar,
      columnMax: calendar ? calendar.sort((a, b) => a.count > b.count ? -1 : 1)[0].count : null
    }
  }
}
</script>

<style lang="stylus">
.history
  padding: 10px
  .calendar
    margin-bottom: 40px
    width: 100%
    display: grid
    grid-template-columns: repeat(30, 1fr)
    // grid-gap: 10px
    .column
      position: relative
      height: 200px
      span
        position: absolute
        bottom: 0px
        display: block
        width: 100%
        background-color: #1da1f2
    .date
      font-size: 1rem
      text-align: center
  h1
    margin-bottom: 40px
  .list
    .anime
      margin-bottom: 40px
      display: grid
      grid-template-columns: 80px auto
      grid-gap: 10px
      .poster
        width: 80px
        height: 115px
        overflow: hidden
        img
          width: 100%
          min-height: 100%
          object-fit: cover
      .body
        .title span
          font-size: 1.4rem
          color: #999
        .items
          margin-top: 10px
          max-height: 200px
          font-size: 1.4rem
          overflow-y: auto
          -webkit-overflow-scrolling touch
          &::-webkit-scrollbar-track
            width: 4px
            background #fff
          &::-webkit-scrollbar
            width: 4px
          &::-webkit-scrollbar-thumb
            background #fff
          &:hover::-webkit-scrollbar-thumb
            background #000
          .item
            padding: 5px
            display: grid
            grid-template-columns: repeat(4, 1fr)
            grid-gap: 10px
            &:nth-child(odd)
              background-color: rgba(29, 161, 242, 0.1)
            &:nth-child(1)
              background-color: rgba(224, 10, 30, 0.1)
</style>